import { useEffect, useState } from "react";
import axios from "axios";
import { Link2Off, KeyRound } from "lucide-react";
import { Loading } from "@/components/Loading";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PasswordLink({ token }) {
  const [info, setInfo] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    axios
      .get(`${API}/public/pw/${token}`)
      .then((r) => setInfo(r.data))
      .catch((e) => setError(e.response?.data?.detail || "Ye link valid nahi hai."));
  }, [token]);

  if (error) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center p-6" data-testid="pw-link-invalid">
        <div className="bg-card border border-border rounded-xl shadow-sm p-8 text-center max-w-sm">
          <Link2Off className="h-10 w-10 mx-auto text-red-400 mb-3" />
          <h1 className="font-heading text-xl font-bold">Link Not Valid</h1>
          <p className="text-sm text-muted-foreground mt-2">{error}</p>
        </div>
      </div>
    );
  }

  if (!info) {
    return <div className="min-h-screen flex items-center justify-center bg-background"><Loading text="Loading..." /></div>;
  }

  return (
    <div className="min-h-screen bg-background" data-testid="pw-link-page">
      <header className="bg-white border-b border-border">
        <div className="h-1 flex">
          <div className="flex-1 bg-cyan-500" />
          <div className="flex-1 bg-pink-600" />
          <div className="flex-1 bg-yellow-400" />
          <div className="flex-1 bg-slate-900" />
        </div>
        <div className="max-w-md mx-auto px-4 py-3 flex items-center gap-3">
          <img src="/logo.webp?v=2" alt="Sootrik" className="h-8 w-auto" />
          <p className="font-heading font-bold text-sm">Sootrik — Password Recovery</p>
        </div>
      </header>
      <main className="max-w-md mx-auto px-4 py-8">
        <div className="bg-card border border-border rounded-xl shadow-sm p-6 space-y-4">
          <div className="flex items-center gap-2">
            <span className="p-2 rounded-lg bg-cyan-50 text-cyan-700"><KeyRound className="h-5 w-5" /></span>
            <h1 className="font-heading text-lg font-bold">Aapki Login Details</h1>
          </div>
          <div className="space-y-3 text-sm">
            <div className="flex justify-between border-b border-border pb-2">
              <span className="text-muted-foreground">Firm Name</span>
              <span className="font-semibold" data-testid="pw-link-firm">{info.firm_name}</span>
            </div>
            <div className="flex justify-between border-b border-border pb-2">
              <span className="text-muted-foreground">Mobile No.</span>
              <span className="font-semibold" data-testid="pw-link-mobile">{info.mobile}</span>
            </div>
            <div className="flex justify-between border-b border-border pb-2">
              <span className="text-muted-foreground">Password</span>
              <span className="font-mono font-bold text-cyan-700" data-testid="pw-link-password">{info.password}</span>
            </div>
          </div>
          <p className="text-xs text-muted-foreground">Ab login page par apni Firm Name aur ye Password dalkar login karein. Ye link sirf aapke liye hai — kisi se share na karein.</p>
        </div>
      </main>
    </div>
  );
}
